<div class="flex">
  <div class="flex-1 separator pr-small-r mr-small-r overflow-hidden" [class.separator--solid]="!isLegacy()">
    @if (arrival() && departure()) {
      <fcom-timeline
        [arrival]="arrival()"
        [departure]="departure()"
        [isByBusOnly]="isByBusOnly()"
        [isByTrainOnly]="isByTrainOnly()"
      />
    }
  </div>
  <div class="bound-details flex" [style.minWidth]="0">
    @if (tails().length) {
      <div class="flex--nogrow flex mr-xxsmall-r ms-xxsmall-b" aria-hidden="true">
        @for (tail of tails(); track tail; let i = $index) {
          <div class="flex--nogrow tail {{ tail }}" [class.first]="i === 0" [class.minus-margin]="i !== 0"></div>
        }
      </div>
    }

    <div class="font-body-2 flex flex--column grow font-body-small">
      @if (airlines().length > 0) {
        <div class="flex--nogrow nordic-blue-900-text text-icon-primary overflow-hidden two-lines-ellipsis">
          <span class="is-vishidden">
            {{ 'bookingSummary.operatedBy' | finLocalization }}
          </span>
          {{ airlines().join(', ') }}
        </div>
      }

      @if (showFlightNumber && flightNumbers()?.length > 0) {
        <div
          data-testid="flight-numbers"
          class="truncate overflow-hidden font-body-2 nordic-blue-400-text text-icon-secondary ps-xxsmall-b font-body-small"
        >
          {{ flightNumbers() }}
        </div>
      }

      @if (duration() || stops() !== undefined) {
        <div class="flex--nogrow flex flex--wrap overflow-hidden">
          @if (stops() !== undefined) {
            <span class="stops-label truncate overflow-hidden" [class.bold-type]="isLegacy()">
              <ng-container
                >{{
                  'flightItinerary.' +
                    (stops() === 0 ? 'direct' : 'stopOver.' + (stops() === 1 ? 'singular' : 'plural'))
                    | finLocalization: [stops()]
                }}<span>&nbsp;</span></ng-container
              >
            </span>
          }
          @if (duration()) {
            <span class="truncate overflow-hidden">{{ duration() }}</span>
          }
        </div>
      }

      @if (showViewDetails()) {
        <div class="flex-2 flex flex--align-end ms-xxsmall-t">
          <button
            class="font-body-2 nordic-blue-900-text text-icon-primary blue-light-hover medium-type underline overflow-hidden align-left font-label-small"
            #viewDetailsBtn
            data-testid="ufo-open-modal-button"
            (click)="viewDetails.emit($event)"
          >
            {{ viewDetailsBtnKey() | finLocalization }}
          </button>
        </div>
      }
    </div>
  </div>
</div>
